export type RoomSizes = {
    width: number
    height: number
    depth: number
}
export type RoomTextures = {
    floor: TextureMaps
    wall: TextureMaps
}

export type MaterialItem = {
    NAME: string
    ID: number
    CODE: string
    NOMPROP_ID: string
    NOMPROP_CODE: string
    NOMPROP: string
    DESCRIPTION: string
    IMG: string
    TEXTURE_MAP: string
    TEXTURE_BUMP: string | null
    TEXTURE_REFL: string | null
    id: number
    title: string
    type: string
    description: string
    imageUrl: string
}

export type TextureMaps = {
    map: string,
    bumpMap: string,
    aoMap: string,
}

export type StepPathType = "dimensions" | "sections" | "items" | "colors" | "view" | "specification";

export enum StepLabel {
    dimensions = "ГАБАРИТЫ",
    sections = "СЕКЦИИ",
    items = "НАПОЛНЕНИЕ",
    colors = "ЦВЕТА",
    view = "ПРОСМОТР",
    specification = "СПЕЦИФИКАЦИЯ",
}
